import styled from "styled-components";

import { typography } from "globalConstants";
import { Default } from "Types";

export type PropsType = any;

const Wrap = styled.button<Default>`
   ${typography.other.t4}
   background-color: black;
   border: none;
   outline: none;
   color: white;
   width: 439px;
   max-width: 100%;
   height: 41px;
   border-radius: 4px;
   transition-duration: 100ms;
   transition-property: opacity;
   transition-timing-function: ease-in-out;
   cursor: pointer;
   &:active {
      opacity: 0.8;
   }
   &:disabled {
      background-color: ${typography.other.color.gray[2]};
   }
   ${({ css }) => css}
`;

export default function Button(props: PropsType) {
   return (
      <Wrap onClick={props.onClick} className={props.className} style={props.style} css={props.css} disabled={props.disabled}>
         {props.children}
      </Wrap>
   );
}
